import i18next from "i18next";
import { en, th } from "./locales";

export const SupportLanguages = {
	en:"English",
	th:"ภาษาไทย"
};

i18next.init({
	interpolation: {
		// React already does escaping
		escapeValue: false,
	},
	lng: "en", // 'en' | 'es'
	// Using simple hardcoded resources for simple example
	resources: {
		en
	},
});
/**
 * Create message from syntax message from {key:value}
 * Message syntax like 'Hello %{username}, how are you?' replace with {username:'BOBO'}
 * @param {string} message 
 * @param {object} values 
 */
export function fromSyntax(message, values){
	const keys = Object.keys(values);
	let msg = message;
	keys.forEach(key => {
		msg = msg.replace(`%{${key}}`, values[key]);
	});
	return msg;
}
export function fromIndex(message, values){
	let msg = message;
	(Array.isArray(values) ? values : [values])
		.forEach((value, index) => {
			msg = msg.replace(`{${index}}`, value);
		});
	return msg;
}
export default i18next;


// WEBPACK FOOTER //
// ./src/i18n/index.js